module.exports = new __parcel__URL__("porcelain_throne_level_1.8a517820.png").toString();